import { render, staticRenderFns } from "./SamCheckbox.vue?vue&type=template&id=e712a96c&scoped=true&shadow"
import script from "./SamCheckbox.vue?vue&type=script&lang=js&shadow"
export * from "./SamCheckbox.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamCheckbox.vue?vue&type=style&index=0&id=e712a96c&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e712a96c",
  null
  ,true
)

export default component.exports